var config = {
    widthTriggerScale: 9999,
    widthDesktopSafe: 1620,
    widthDesktop: 1920,
    widthMobile: 640,
    heightDesktop: 1000,
    heightMobile: 1000,
    func: {
        isMobile: function(){
            var device = {
                width: $(window).innerWidth(),
                height: $(window).innerHeight()
            };

            // return ((device.width <= config.widthMobile) || (device.width < device.height));
            return ((device.width < 999) && (device.width <= device.height));
        }
    }
}

export default config;